var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('baseline-layout',[_c('v-container',{attrs:{"slot":"main"},slot:"main"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('h1',[_vm._v("Microsoft Word")])])],1),_c('v-row')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }